<template>
     <div 
        v-on-clickaway="closeDropdown" 
        class="absolute top-full left-0 mt-2 w-[250px] bg-white rounded-lg shadow-lg z-50">
        <div class="modal-content-board">
        <!-- Close Button -->
        <woot-button
          icon="dismiss"
          class="button modal--close clear button--only-icon secondary"
          @click="$emit('close')"
        />
  
        <h3 class="text-[15px]  mt-[8px] font-semibold">Select Pipeline</h3>
  
        <!-- Search Bar -->
        <div class="mt-4">
        <input
          type="text"
          v-model="search"
          placeholder="Search pipeline..."
          class="search-input w-full border border-gray-300 rounded-md px-1.5 py-0.5 text-sm mb-2"
        />
        </div>
  
        <!-- State List -->
        <div class="mt-2 max-h-32 overflow-y-auto">
            <LabelDropdownItem
            v-for="state in filteredStates"
            :key="state.id"
             :title="state.name"
            :color="state.color"
            :selected="state.id === selectedStatus?.id"
            :class="{ 'disabled-item': state.id === selectedStatus?.id }" 
            :disabled="state.id === selectedStatus?.id" 
            @click="state.id !== selectedStatus?.id && selectState(state)" 
          />
          <div
            v-if="noResult"
            class="text-sm text-gray-600 px-4 py-4 text-center"
          >
            No results found
          </div>
        </div>
        <div class="mt-1 px-2">
         <div v-if="selectedStatus" class="flex items-center justify-between bg-gray-100 p-2 rounded-md">
           <span class="text-sm font-medium">{{ selectedStatus.name }}</span>
        
         </div>
       </div>
      </div>
    </div>
  </template>
  
  <script>
  import LabelDropdownItem from 'shared/components/ui/label/LabelDropdownItem.vue';
  import { picoSearch } from '@scmmishra/pico-search';
  import { mixin as clickaway } from 'vue-clickaway';
  import { mapGetters } from 'vuex';

  export default {
    components: { 
        LabelDropdownItem },
    mixins: [clickaway],    
    props: {
      states: {
        type: Array,
        required: true,
      },
      selectedStatus: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        search: '',
      };
    },
    computed: {
      ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
      filteredStates() {
        const base = !this.search
          ? this.states
          : picoSearch(this.states, this.search, ['name'], { threshold: 0.9 });
        return base.filter(s => s.agent_dragable == true || this.currentUser.role == 'administrator');
      },
      noResult() {
        return this.filteredStates.length === 0 && this.search.trim() !== '';
      },
    },
    methods: {
      closeDropdown() {
      this.$emit('close'); // Emit the close event to the parent
    },
      selectState(state) {
        this.$emit('select', state); // Emit the selected state to the parent
        this.$emit('close'); // Close the modal after selection
      },
    },
  };
  </script>
  
  <style scoped>
  .modal-content-board {
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
}

.disabled-item {
  pointer-events: none; /* Disable interactions */
  /* opacity: 0.5; */
}
  /* No custom CSS needed */

.dark .text-sm{
  color: #3C4858;
}
  </style>